import { useEffect } from 'react';
import Spinner from '@/components/Spinner.tsx';
import useAxiosInterceptors from '@/hooks/useAxiosInterceptors.tsx';
import { useClientQuery } from '@/hooks/useClientQuery';
import { useEntityConfig } from '@/hooks/useEntityConfig.tsx';

export default function SocialTradingHandler() {
  const axiosPrivate = useAxiosInterceptors();
  const config = useEntityConfig();
  const clientQuery = useClientQuery();

  useEffect(() => {
    if (clientQuery.isLoading) {
      return;
    }

    if (clientQuery.data?.client_details?.accounts?.length === 0) {
      window.location.href = `/services/empty-accounts`;

      return;
    }

    const handleSocialTradingSession = async () => {
      try {
        const response = await axiosPrivate.post(`/sessions/applications/social-trading`);
        const {
          data: { access_token = null },
        } = response;

        if (!access_token) throw new Error();

        window.location.href = `${config.VITE_SOCIAL_TRADING_URL}?a=1&token=${access_token}`;
      } catch {
        window.location.href = `/`;
      }
    };

    handleSocialTradingSession();
  }, [axiosPrivate, clientQuery.isLoading, clientQuery.data]);

  return <Spinner />;
}
